/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.mulchcalculator = (await import('./pages/mulch-calculator/MulchCalculatorContainer')).MulchCalculatorContainer;
    Components.movingboxcalculator = (await import('./pages/moving-calculator/MovingCalculatorContainer')).MovingCalculatorContainer;
    Components.home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({

  mulchcalculator: {
    name: 'MulchCalculatorContainer',
    componentName: 'MulchCalculatorContainer',
    chunk: () => import('./pages/mulch-calculator/MulchCalculatorContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.mulchcalculator
        : currentRouteName === 'MulchCalculatorContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.MulchCalculatorContainer })));
    },
    path: '/:context?/calculator/mulch/',
    channel: null
  },
  movingboxcalculator: {
    name: 'MovingCalculatorContainer',
    componentName: 'MovingCalculatorContainer',
    chunk: () => import('./pages/moving-calculator/MovingCalculatorContainer'),
    get component() {
      return ssr
      // eslint-disable-next-line max-len
        ? serverPages.movingboxcalculator
        : currentRouteName === 'MovingCalculatorContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.MovingCalculatorContainer })));
    },
    path: '/:context?/c/:slug',
    channel: null,
    // varnish: true
  },
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/calculator/',
    channel: null
  },
});
